
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqj5WKRPla0edM6zrTSiiPWrwkWygiHcdO_HEgE5IgzWMMeta } from "/codebuild/output/src1112770653/src/src/pages/faq.vue?macro=true";
import { default as menu_v8TH4vlp97lAhRBK4tVdcDHkCG3_452w4TUcUKWQrMLQMeta } from "/codebuild/output/src1112770653/src/src/pages/menu.vue?macro=true";
import { default as indexhoMfCw_aKJ_zy9guzPdJJr7HOk7Gta2VEO2Obo6r_454kMeta } from "/codebuild/output/src1112770653/src/src/pages/index.vue?macro=true";
import { default as contactaCEASfP0NrvmivpNB12nQZ_45mM9JHB_45YAq8Mr0DFaEyIMeta } from "/codebuild/output/src1112770653/src/src/pages/contact.vue?macro=true";
import { default as tutorialE_lV7EKoKTzHmj80iwJBzetYB9db_PMvwkMEh7cIGHcMeta } from "/codebuild/output/src1112770653/src/src/pages/tutorial.vue?macro=true";
import { default as agreement3fhXUKEVwYGG15wAp_45gz_457XD6I9YPb_WQfxrrViU6hgMeta } from "/codebuild/output/src1112770653/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass3_Bq59gxLPUu_45jzZ2q_KjhhvQYB5EfhfyPEgRgMJ0zAMeta } from "/codebuild/output/src1112770653/src/src/pages/about-pass.vue?macro=true";
import { default as indexLzPtO2Q2mgwjbYHx2kkqssKcmbBgbPJBw_aTi5V5jqIMeta } from "/codebuild/output/src1112770653/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Pn6_JJuAeJcA1r0C8vAFisVTQ0LrygBb1e7QmGN8iooMeta } from "/codebuild/output/src1112770653/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceuTsQTi9H0ScKGiuicki1ssAqAVHdv7k2Zw9ms27sxwAMeta } from "/codebuild/output/src1112770653/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93YzMo5qR4XKqm7GSlNFcac44f2EbSdKLZFb0ARBYfeKoMeta } from "/codebuild/output/src1112770653/src/src/pages/notice/[id].vue?macro=true";
import { default as indexb79kAM8gaZxjk4zUyk_cMXQTN7peiMfNVXwJcCIHcZ8Meta } from "/codebuild/output/src1112770653/src/src/pages/coupon/index.vue?macro=true";
import { default as indexUdF6mivmh4eVtfvjMKZtJOY94PcRNChroV0DPIX69DEMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/index.vue?macro=true";
import { default as indexRwYSRbGCp1AUzewUtj4_45HpHHKSeSYSFakHjOcHd7k3EMeta } from "/codebuild/output/src1112770653/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93_N8sllxgDKoD40X76lYxOoape_UqLD_45zvMRIcLgB1DEMeta } from "/codebuild/output/src1112770653/src/src/pages/parking/[id].vue?macro=true";
import { default as index_oo_45KIBFd3MJ1Sp0q0JdYmyGse5nmX2_458j__45tcJDcWYMeta } from "/codebuild/output/src1112770653/src/src/pages/history/index.vue?macro=true";
import { default as indexFqxKNft823WpWR1cdaygVFLowdyqzNGYN1i6GviviwwMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/index.vue?macro=true";
import { default as indexNHx6mA7XDwYYAqMynUjiNTol051v7r8zbkSX8p0m0v4Meta } from "/codebuild/output/src1112770653/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexMdxw8I1NZWPLJEQ9nX7FRaymdZJDPDv1oS8Gr7TnjdIMeta } from "/codebuild/output/src1112770653/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviyzSShcaRft3RVQdH8OcSLQemjWgs2g38c_45jDxRJNxpIMeta } from "/codebuild/output/src1112770653/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editEeXIDgKXdJW0PQ7savxWp0uGlqC805LeHN_45JPvzoMSoMeta } from "/codebuild/output/src1112770653/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementM13EkGeH194YY698rbvvSuwy_45kiA6zYAGekTThkgw40Meta } from "/codebuild/output/src1112770653/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexxcH2wKyqKOejM_Md4feu31izSdgffRzaUuvb9RG3IKQMeta } from "/codebuild/output/src1112770653/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d6vfxGVQc3d7SwA_Y9NWcTg8uwAA4_fooDj4beJT1QpEMeta } from "/codebuild/output/src1112770653/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmBpI9YAu92y4DSS19tuiXToZIuAi5rrgqMJrN3re_45B_8Meta } from "/codebuild/output/src1112770653/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexrxN7Uuh_45lkqk8Tn_45dBZsojXzjCWDT6Y7RNbxr7FAtwYMeta } from "/codebuild/output/src1112770653/src/src/pages/card/create/index.vue?macro=true";
import { default as indexKF6CTXQ3F1_foBNOPpp_45CEGAz1oLo23rUcNzdqjzAFUMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmNcUynJFN9kTzZ1feIMP4sJTRA_45IdC341M9TetTibnbUMeta } from "/codebuild/output/src1112770653/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmyHEvM9MI1lOeQuenVLnks0wV_45eEBU9jETRwkAoJjtN0Meta } from "/codebuild/output/src1112770653/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete2JH8o0mKqLjisxKQ3W_rHfXnwtRInSOGJKUZYP692f8Meta } from "/codebuild/output/src1112770653/src/src/pages/membership/complete.vue?macro=true";
import { default as registerZwNT3KZ8YwQGA2CP9yL2q4Tscuxj7JsmT1G8tZa9PaIMeta } from "/codebuild/output/src1112770653/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93_vniQZSmJQfIVGIf28lkQ9nyA7UfM8yTNQ_45404JddOwMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm9yih9bYjvRbkojLhuNMr4mfxcIMRfXTbOp8IQDXYWWsMeta } from "/codebuild/output/src1112770653/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93XwOP0fkLooxg_5Gf0juSocr7F_45bHQq8RKdmM6E6f7jAMeta } from "/codebuild/output/src1112770653/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexXFAuEShIdxxEN1LHzggYBQFBFwi2lN9EPttajIPZAScMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeso8BohQtD_ivieS1qSWhTQX7sSesNiGbttTnOT4NCqQMeta } from "/codebuild/output/src1112770653/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code4hK8vwV8s_45Oenr0TmkzkWUy1raPI57YFKWE0SARcMScMeta } from "/codebuild/output/src1112770653/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeVJTm7UxBILlp20ayCjjj8FBg_eDDDwY93lUE6HBeXksMeta } from "/codebuild/output/src1112770653/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerWD45uC9Mk2D2Lrr7uwvShyW0TulPaBAgh4rdBwAVbOQMeta } from "/codebuild/output/src1112770653/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeHuWS4W54iZs5yy0i6vzZhrDPZn8Ol66IF61VHbQcywAMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexzkihfR5RARg0jIsUsO5UEoTlRzB2dNxBq_IFRzpCfi8Meta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmZ52JYJiZMGKOrg33dHMTAZuDh9TNJP1Z9vFUmE6tv7gMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeGJM0C_B_4598ifEAdcg1LUESszTIwPbLP9T51AuImAMygMeta } from "/codebuild/output/src1112770653/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index2UtOy189hrCrTsirdw_mK9vbextnnlJExN8C9bk13R8Meta } from "/codebuild/output/src1112770653/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93mphRtQEC9QyoZiFzYQVxvFrIN2uskwb47KBzgVCnba8Meta } from "/codebuild/output/src1112770653/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete_45bgZgMIG9_45mpB57whPV1BMgFJa4_45JkhOSSKBERMfydQMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias3vd_45XB_jNc6IYa_45PjH6fnW9O7eAt1BrFc6YDdiqWunQMeta } from "/codebuild/output/src1112770653/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplefPrw7PzbLkDjN16lBhwjZK3PjPo5Cxc9DvVa8OanJX8Meta } from "/codebuild/output/src1112770653/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailNnXSh4M6vCedX0r1cSlPjBoag79ZwW9W72LSI9Xqf0QMeta } from "/codebuild/output/src1112770653/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmqpXLRjUVILEiFgjQcdHeWypv_HeJLWVHpGlaVvoS9IoMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentsNSedGCRYgLc407Z_JY5lqUdttSl_45T85uFuO0F7SmoIMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm8D1_45Az3wcnAw__458IKiu_QNcYk1bLnzF29jr4DiagHRQMeta } from "/codebuild/output/src1112770653/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateTlUENxzYwyToAcgdn_9asygMVSUry0xfi9DbFTlDGqkMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete9BFSpT_nde4rvDn3t8uP4QYEcYcTr2H1iOOqGYyhJ0wMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeWXMhSxLnHuCuYBkfTVHJ5jZ09sntqB_EeZo7g1OnrqoMeta } from "/codebuild/output/src1112770653/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordgTIPog192U5el3HAI9wAH5cfgL4IYEgYjKkbMvO5_45GkMeta } from "/codebuild/output/src1112770653/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliassgftNN3GWii4RKmzvEsi7494u1DmG_OHoe_45gwGwr2tcMeta } from "/codebuild/output/src1112770653/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerNZxp5Asj3hQO9u6_45jDDjzUGVl5YaZNnEopBpIizBPikMeta } from "/codebuild/output/src1112770653/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeW_RYxBvbsQysNKChtpgMRk6n_tEDH70fA4Ym6i5dn8IMeta } from "/codebuild/output/src1112770653/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexptMEofyH4NhU1YlTMvnNKB_45OtjP4rxeRyZORAC20dSIMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index449_qOsd4ZTkesWWdO9qBtSNQUgQ9ng1lCqDotIqzEYMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexZu3oNpWBb9yB99rBQgNnLtQr1MzUe0o_mNxIT4_45737wMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index_YIbDF2GWha3hTKGqdwlGaJuk3Gyv1BiQWV7ZBttqpEMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateluGlbbt1YYa1sdu2xyjpcJjPz498Ied23UmSvShjkFEMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeFrosHgZbIXqdXHedySk6rOs2URKNz88KDdhrGog8fTQMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmZb76X3k_45bL9bHelppwN0HWo966dtuqymj9JBWkWYjHYMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexvQlkq1cHWBqVhaWYJp_sPCd6IS0VFyCRIY_i3Lb2pbMMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete8rpfui0KdPZH4I_455Jb4V92E3bV2VPH93TtJ4ztgWEZoMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateOxCv3kQ9AHyUZ0mGnAYw9DuE5H50d4RNIu7HF7vplgAMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexuMrY7FbId_5cSW8bpiQXg8aOLyynfTdrCrYNfTFXgd4Meta } from "/codebuild/output/src1112770653/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexHbml4pjT9LAssYu2ixInGuS1Ut5bSBKfFcKwx2yvOFUMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete01coHnolJHOblAbxN6xyP3RMHBp4HsFuXqdFMpe3t_45IMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexagfXVUSSV_45S0RoNmLtXoHOZeyJtWyJItawyZDbiQ36YMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code17162KsR_gTfs9rwqrMYzsuQr_rMJ3oQplZ36SlzZEUMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexSczZCCfQnK_plJmw5cwQBAi_4o_45lKHZ0za_45F8ITdrKgMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexzUxd5l2yQ99lwjNr51vySvUGjPnr7yB9ru8CJeqCuU4Meta } from "/codebuild/output/src1112770653/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexURDrGHuft8N2wiPXGPELoo9_ikCjme9X_45CZyclmYcqkMeta } from "/codebuild/output/src1112770653/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update5mjjVCnCDnlMPoTmZVmCiNNfjC7o6TUra4SfNF8KFqQMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmmFfMrYrUesUxB5_45SGMCWeTLrj_45gljIRmq6ZOa9zK6gAMeta } from "/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu_v8TH4vlp97lAhRBK4tVdcDHkCG3_452w4TUcUKWQrMLQMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexhoMfCw_aKJ_zy9guzPdJJr7HOk7Gta2VEO2Obo6r_454kMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexb79kAM8gaZxjk4zUyk_cMXQTN7peiMfNVXwJcCIHcZ8Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index_oo_45KIBFd3MJ1Sp0q0JdYmyGse5nmX2_458j__45tcJDcWYMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexNHx6mA7XDwYYAqMynUjiNTol051v7r8zbkSX8p0m0v4Meta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexMdxw8I1NZWPLJEQ9nX7FRaymdZJDPDv1oS8Gr7TnjdIMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexrxN7Uuh_45lkqk8Tn_45dBZsojXzjCWDT6Y7RNbxr7FAtwYMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmNcUynJFN9kTzZ1feIMP4sJTRA_45IdC341M9TetTibnbUMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmyHEvM9MI1lOeQuenVLnks0wV_45eEBU9jETRwkAoJjtN0Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete2JH8o0mKqLjisxKQ3W_rHfXnwtRInSOGJKUZYP692f8Meta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerZwNT3KZ8YwQGA2CP9yL2q4Tscuxj7JsmT1G8tZa9PaIMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm9yih9bYjvRbkojLhuNMr4mfxcIMRfXTbOp8IQDXYWWsMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeso8BohQtD_ivieS1qSWhTQX7sSesNiGbttTnOT4NCqQMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code4hK8vwV8s_45Oenr0TmkzkWUy1raPI57YFKWE0SARcMScMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeVJTm7UxBILlp20ayCjjj8FBg_eDDDwY93lUE6HBeXksMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerWD45uC9Mk2D2Lrr7uwvShyW0TulPaBAgh4rdBwAVbOQMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmZ52JYJiZMGKOrg33dHMTAZuDh9TNJP1Z9vFUmE6tv7gMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeGJM0C_B_4598ifEAdcg1LUESszTIwPbLP9T51AuImAMygMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index2UtOy189hrCrTsirdw_mK9vbextnnlJExN8C9bk13R8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete_45bgZgMIG9_45mpB57whPV1BMgFJa4_45JkhOSSKBERMfydQMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplefPrw7PzbLkDjN16lBhwjZK3PjPo5Cxc9DvVa8OanJX8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailNnXSh4M6vCedX0r1cSlPjBoag79ZwW9W72LSI9Xqf0QMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmqpXLRjUVILEiFgjQcdHeWypv_HeJLWVHpGlaVvoS9IoMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentsNSedGCRYgLc407Z_JY5lqUdttSl_45T85uFuO0F7SmoIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm8D1_45Az3wcnAw__458IKiu_QNcYk1bLnzF29jr4DiagHRQMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete9BFSpT_nde4rvDn3t8uP4QYEcYcTr2H1iOOqGYyhJ0wMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeWXMhSxLnHuCuYBkfTVHJ5jZ09sntqB_EeZo7g1OnrqoMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordgTIPog192U5el3HAI9wAH5cfgL4IYEgYjKkbMvO5_45GkMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerNZxp5Asj3hQO9u6_45jDDjzUGVl5YaZNnEopBpIizBPikMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeW_RYxBvbsQysNKChtpgMRk6n_tEDH70fA4Ym6i5dn8IMeta || {},
    component: () => import("/codebuild/output/src1112770653/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1112770653/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]